import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { Grid, useTheme } from "@material-ui/core";
import moment from "moment-jalaali";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import HomeService from "Services/http/endpoints/home/HomeService";
import DatePickerComponent from "Components/DatePickerComponent/DatePickerComponent";
import {useSetState} from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { useTranslation } from 'react-i18next';
import { getLocaleDate } from "Helpers/GetLocaleDate";


function BarChart({ data, dataInterval }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [loading, setLoading] = useState(false);
  const [barData, setBarData] = useState(null);
  const [date, setDate] = useState(moment());
  const [toDate, setToDate] = useState(moment());
  const [controls, setControls] = useSetState({
    stateProject: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });


  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        titleFont: {
          family: "IRANSans",
          size: 10,
        },
        bodyFont: {
          family: "IRANSans",
          size: 10,
        },
        footerFont: {
          family: "IRANSans",
          size: 10,
        }
      },
      legend: {
        // rtl: true,
        position: "top",
        labels: {
          font: {
            family: "IRANSans",
            size: 12,
          },
        },
      },
      title: {
        display: true,
        font: {
          family: "IRANSans",
          size: 12,
        },
        text: t('unitsNumber_renovation_reconstruction')
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            family: 'IRANSans',
            size: 12,
          },
        },
      },
      y: {
        ticks: {
          font: {
            family: 'IRANSans',
            size: 12,
          },
        },
      }
    }
  };

  /* const data = {
    labels: ["فروردین", "اریبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر"],
    datasets: [
      {
        label: "UPVC",
        data: [208, 695, 780, 886, 702, 338, 352],
        backgroundColor: "#47cec0",
      },
      {
        label: "آلمینیوم",
        data: [747, 619, 503, 398, 912, 865, 141],
        backgroundColor: "#5c9def",
      },
    ],
  };*/

  const onChange = (value) => {
    setDate(value);
  };

  const onChangeToDate = (value) => {
    setToDate(value);
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onFinish = async () => {
    const {stateProject} = controls;
    const newDate = getLocaleDate(date, direction);
    const newToDate = getLocaleDate(toDate, direction);
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Date: newDate + "-" + newToDate,
        Interval:+stateProject.value.value,
      };
      const response = await HomeService.getBar(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setBarData(response.data.Value);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dataInterval) {
      const items = dataInterval.map((m) => {
        return {
          ...m,
          value: m.Id,
          label: m.Name,
        };
      });
      setControls({ stateProject: { selectItems: items } });
      setControls({ stateProject: { value: items[0] } });
    }
  }, [dataInterval]);

  useEffect(() => {
    setBarData(data);
  }, [data]);

  return (
    <>
      <BackDropLoading loading={loading}  />
      <Grid container spacing={2} className="p-2">
        <Grid item xs={6} md={3}>
          <DatePickerComponent
            label={t('fromDate')}
            value={date}
            onChange={onChange}
          />
        </Grid>

        <Grid item xs={6} md={3}>
          <DatePickerComponent
            label={t('toDate')}
            value={toDate}
            onChange={onChangeToDate}
          />
        </Grid>

        <Grid item xs={6} md={3} >
          <MuiAutoComplete
              autoSelect={true}
              loading={loading}
              options={controls.stateProject.selectItems}
              label={<Translator id={"period"} />}
              value={controls.stateProject.value}
              id={"stateProject"}
              onChange={autoCompleteHandler}
          />
        </Grid>

        <Grid item xs={6} md={3} className="margin-top-button no-sm-effect">
          <MuiButton
            color="primary"
            onClick={onFinish}
            className="w-100"
            title={<Translator id="filter" />}
          />
        </Grid>

      </Grid>
      {barData && <Bar options={options} data={barData} type={"bar"} />}
    </>
  );
}

export default BarChart;
